import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCarlines } from 'src/bff';
import { useFaContent } from 'src/feature-app';
import { Steps } from 'src/types';

const getLastItemOfSteps = (steps: Steps[]) => steps[steps.length - 1];

export function useInitializeCallmeForm(defaultSteps: Steps[]) {
	const dispatch = useDispatch();
	const faContent = useFaContent();
	const [loading, setLoading] = useState(true);

	const [steps, setSteps] = useState<Steps[]>(defaultSteps);
	const [firstStep, setFirstStep] = useState<Steps>(defaultSteps[0]);
	const [lastStep, setLastStep] = useState<Steps>(getLastItemOfSteps(defaultSteps));

	const removeModelFromSteps = async () => {
		return new Promise((resolve) => {
			let updatedSteps = [...steps];
			const indexOfModelo = updatedSteps.findIndex((step) => step.name == 'Modelo');
			updatedSteps.splice(indexOfModelo, 1); // Eliminado el step de Modelo.
			updatedSteps[0].hidePreviousStep = true;
			const updatedStepsWithIndex = updatedSteps.map((step, index) => {
				step.screenIndex = index;
				return step;
			});

			setSteps(updatedStepsWithIndex);
			setFirstStep(updatedStepsWithIndex[0]);
			setLastStep(getLastItemOfSteps(updatedStepsWithIndex));

			resolve(true);
		});
	};

	const handleFaContentCarline = async () => {
		await removeModelFromSteps();

		if (!isNaN(Number(faContent.carlines[0]))) {
			// Desde faContent nos llega un carlineCode, consultamos nombre
			const carlines = await getCarlines();
			const selectedCarline = carlines.find((carline) => carline.code == faContent.carlines[0]);

			dispatch({ type: 'UPDATE_FIELDS', payload: { ['modelo']: selectedCarline?.title } });
		} else {
			dispatch({ type: 'UPDATE_FIELDS', payload: { ['modelo']: faContent.carlines[0] } });
		}

		setLoading(false);
	};

	const requestCarlines = async () => {
		const carlines = await getCarlines();

		dispatch({ type: 'SET_CARLINES', payload: carlines });
		setLoading(false);
	};

	useEffect(() => {
		if (faContent?.carlines?.length == 1) {
			handleFaContentCarline();
		} else {
			requestCarlines();
		}
	}, []);

	return { loading, steps, firstStep, lastStep };
}
